import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.performanceWfuhs',
    'package:data.universal.orgStructure.withoutDivisions',
    'resource:data.dimensions.organization.entities.subdepartment',
    'resource:data.dimensions.organization.entities.subdepartment.attributes.shouldAnalyze',
    'resource:solutions.apps.rpWfuhs.pages.explore',
    'resource:solutions.apps.rpWfuhs.pages.overview',
    'resource:solutions.apps.rpWfuhs.pages.trends',
    'resource:solutions.apps.rpWfuhs',
    'resource:solutions.mosaic.pages.rpWfuhs.explore',
    'resource:solutions.mosaic.pages.rpWfuhs.overviewWithPiScatter',
    'resource:solutions.mosaic.pages.rpWfuhs.trends',
    'resource:solutions.mosaic.widgets.rpWfuhs.exploreMetrics',
    'resource:solutions.mosaic.widgets.rpWfuhs.explorePerfComparison',
    'resource:solutions.mosaic.widgets.rpWfuhs.exploreTrends',
    'resource:solutions.mosaic.widgets.rpWfuhs.orgTable',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewDonut',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewMetrics',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewTrends',
    'resource:solutions.mosaic.widgets.rpWfuhs.piScatter',
    'resource:solutions.mosaic.widgets.rpWfuhs.piTable',
    'resource:solutions.mosaic.widgets.rpWfuhs.projectsTable',
    'resource:solutions.mosaic.widgets.rpWfuhs.spaceTable',
    'resource:solutions.mosaic.widgets.rpWfuhs.sponsorsTable',
    'resource:solutions.mosaic.widgets.rpWfuhs.trendsStacked',
    'resource:solutions.mosaic.widgets.rpWfuhs.trendsTable',
  ],
  description: 'Standard Research Performance',
  name: 'RP',
} as const satisfies core.quiver.Package
